import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { requestWellnessArticles, type WellnessArticlesRequest, wellnessArticlesKey } from './wellnessApi';

/**
 * One page of HealthDay wellness articles, newest first (or by relevance while `search` is set).
 * `keepPreviousData` holds the previous page on screen while the next loads, so paging and
 * searching swap cards in place instead of flashing the skeleton.
 */
export function useWellnessArticles(input: WellnessArticlesRequest, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: [...wellnessArticlesKey, input],
    queryFn: () => requestWellnessArticles(input),
    placeholderData: keepPreviousData,
    enabled: options?.enabled,
  });
}
